import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BusinessDataService } from 'src/app/data-repositories/business-data.service';

@Component({
  standalone: false,
  selector: 'app-request-password',
  templateUrl: './request-password.component.html',
  styleUrls: ['./request-password.component.scss']
})
export class RequestPasswordComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router, private service: BusinessDataService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {

      const code = params.code;
      const username = params.username;
      this.service.getPassword(code, username);
      this.router.navigate(['']);
    });
  }

}
